export const baseUrl = "https://api.soomha.net/api/",
headerConfigKeyName = "SoomhaDashBoard"

